module.exports = __webpack_public_path__ + "media/icons-lj-styleguide-2025/check-purple-300176ce.svg";